<template>
    <div>
        <template v-if="wholesaler === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <div class="pm-employee-info float-left">
                   <h1> Order Details </h1>
                </div>
                <router-link to="/orders" class="btn btn-primary mt-2 float-right"> Close</router-link>
                <button v-if="print_order_details" @click="printOrderDetails(order_id)" class="btn btn-primary mt-2 float-right mr-1">Print Order</button>
            </div>
            <div class="page-top mb-1 mb-3">
                <div class="pm-employee-view-main">
                    <div class="row">
                        <div class="col-md-12">
                            <label class="label block-label highlight-color mb-3 clearfix">
                                <span class="highlight-color float-left">Order</span>
                            </label>
                            <div class="pm-employee-detail-box mb-3">
                                <div class="row mb-2">
                                    <div class="col-md-4">
                                        <strong class="title">Shop:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <p>{{ order.shop_name }}</p>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-md-4">
                                        <strong class="title">Shop Address:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <p>{{ order.shop_address }}</p>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-md-4">
                                        <strong class="title">Wholesaler:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <p>{{ order.company_name }}</p>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-md-4">
                                        <strong class="title">Date:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <p>{{ order.order_date | date_format }}</p>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-md-4">
                                        <strong class="title">Status:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <p>{{ order.order_status}}</p>
                                    </div>
                                </div>
                                <div v-if="order.order_reject_reason != ''" class="row mb-2">
                                    <div class="col-md-4">
                                        <strong class="title">Reason:</strong>
                                    </div>
                                    <div class="col-md-8">
                                        <p>{{ order.order_reject_reason }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <label class="label block-label highlight-color mb-3 clearfix">
                                <span class="highlight-color float-left">Items / Products</span>
                            </label>
                            <div class="table-holder">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Sr No.</th>
                                            <th>Item Name</th>
                                            <th>Price <small>(Per Item)</small></th>
                                            <th>Discount <small>(Per Item)</small></th>
                                            <th>Qty</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(order_detail,index) in order_details" v-bind:value="order_detail.id" v-bind:key="order_detail.id">
                                            <td>{{index+1}}</td>
                                            <td>{{order_detail.name}}</td>
                                            <td>{{order_detail.price}}</td>
                                            <td>{{order_detail.discount}}</td>
                                            <td>{{order_detail.qty}}</td>
                                            <td>{{(order_detail.price - order_detail.discount) * order_detail.qty}}</td>
                                        </tr>
                                        <tr class="border border-right-0 border-left-0 border-bottom-0 border-dark">
                                            <td colspan="4"></td>
                                            <td><b>Total Amount:</b></td>
                                            <td><b>{{ order.total_amount }}</b></td>
                                        </tr>
                                        <tr>
                                            <td colspan="4"></td>
                                            <td><b>Total Discount:</b></td>
                                            <td><b>{{ order.total_discount }}</b></td>
                                        </tr>
                                        <tr>
                                            <td colspan="4"></td>
                                            <td><b>Net Amount:</b></td>
                                            <td><b>{{ order.net_amount }}</b></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="global-main">
                   
            </div>
        </template>
        <template v-else-if="wholesaler === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="wholesaler === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                order: [],
                order_details: [],
                wholesaler: null,
                print_order_details: 1,
                order_id: this.$route.params.id,
                serial_num: 1
            }
        },
        mounted() {
            this.$Progress.start();
            this.can('wholesaler').then(result => {
                this.wholesaler = result.wholesaler;
            }).then(result => {
                if(this.wholesaler == true){
					this.getOrderDetails();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            getOrderDetails(){
                axios.get('/api/wholesaler/orderDetails?order_id='+this.$route.params.id)
                .then(res => {
                    if(res.data.code == 200){
                        this.order = res.data.data.order;
                        this.order_details = res.data.data.order_details;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            printOrderDetails(order_id) {
                this.$Progress.start();
                axios.get('/api/downloadOrder/'+order_id, {responseType: 'arraybuffer'})
                .then((response) => {
                    if(response.status == 200){
						const url = URL.createObjectURL(new Blob([response.data], {
						type: 'application/vnd.ms-excel'
					}))

					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'OrderDetails.xlsx')
					document.body.appendChild(link)
					link.click();
					}else{
						this.$Progress.fail();
						swal.fire({
							type: 'error',
							title: 'Error to load form data...'
						});
					}
                });
            }
        }
    }

</script>
